import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Home from './pages/Home';
import WhyAfrica from './pages/WhyAfrica';
import Partners from './pages/Partners';
import About from './pages/About';
import Ecosystem from './pages/Ecosystem';
import Opportunity from './pages/Opportunity';
import Invest from './pages/Invest';
import Team from './pages/Team';
import Sankofa from './pages/Sankofa';
import ClimateImpact from './pages/ClimateImpact';
import Tokenomics from './pages/Tokenomics';
import TermsConditions from './pages/TermsConditions';
import FAQ from './pages/FAQ';
import News from './pages/News';
import BlogDetail from './pages/BlogDetail';
import StrategicRound from './pages/StrategicRound';
import { AuthProvider } from './admin/AuthContext';
import ProtectedRoute from './admin/ProtectedRoute';
import AdminLogin from './admin/AdminLogin';
import AdminLayout from './admin/AdminLayout';
import AdminUsers from './admin/AdminUsers';
import AdminAdmins from './admin/AdminAdmins';
import './index.css';

const PAGE_TITLES: Record<string, string> = {
  '/': 'Azura Mobility | Powering Africa\'s Electric Future',
  '/why-africa': 'Why Africa | Azura Mobility',
  '/partners': 'Partners | Azura Mobility',
  '/about': 'About Us | Azura Mobility',
  '/ecosystem': 'Ecosystem | Azura Mobility',
  '/opportunity': 'The Opportunity | Azura Mobility',
  '/invest': 'Invest | Azura Mobility',
  '/team': 'Our Team | Azura Mobility',
  '/climate-impact': 'Climate Impact | Azura Mobility',
  '/sankofa': 'Sankofa | Azura Mobility',
  '/tokenomics': 'Tokenomics | Azura Mobility',
  '/terms': 'Terms & Conditions | Azura Mobility',
  '/faq': 'FAQ | Azura Mobility',
  '/news': 'News | Azura Mobility',
  '/strategic-round': 'Strategic Round | Azura Mobility',
};

const ScrollToTop: React.FC = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
    document.title = PAGE_TITLES[pathname] ?? (pathname.startsWith('/proadmin') ? 'Admin | Azura Mobility' : 'Azura Mobility');
  }, [pathname]);
  return null;
};

const AppShell: React.FC = () => {
  const { pathname } = useLocation();
  const isAdmin = pathname.startsWith('/proadmin');

  return (
    <div className="flex min-h-screen flex-col">
      {!isAdmin && <Navbar />}
      <main className="flex-1">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/why-africa" element={<WhyAfrica />} />
          <Route path="/partners" element={<Partners />} />
          <Route path="/about" element={<About />} />
          <Route path="/ecosystem" element={<Ecosystem />} />
          <Route path="/opportunity" element={<Opportunity />} />
          <Route path="/invest" element={<Invest />} />
          <Route path="/team" element={<Team />} />
          <Route path="/climate-impact" element={<ClimateImpact />} />
          <Route path="/sankofa" element={<Sankofa />} />
          <Route path="/tokenomics" element={<Tokenomics />} />
          <Route path="/terms" element={<TermsConditions />} />
          <Route path="/faq" element={<FAQ />} />
          <Route path="/news" element={<News />} />
          <Route path="/news/:slug" element={<BlogDetail />} />
          <Route path="/strategic-round" element={<StrategicRound />} />

          {/* Admin — intentionally not linked from the public Navbar */}
          <Route path="/proadmin/auth" element={<AdminLogin />} />
          <Route path="/proadmin" element={<ProtectedRoute><AdminLayout /></ProtectedRoute>}>
            <Route index element={<AdminUsers />} />
            <Route path="users" element={<AdminUsers />} />
            <Route path="admins" element={<ProtectedRoute requiredRole="super_admin"><AdminAdmins /></ProtectedRoute>} />
          </Route>
        </Routes>
      </main>
      {!isAdmin && <Footer />}
    </div>
  );
};

function App() {
  return (
    <Router>
      <AuthProvider>
        <ScrollToTop />
        <AppShell />
      </AuthProvider>
    </Router>
  );
}

export default App;
